import React from "react";
import Clock from "~/components/Clock";
import LanguageSelector from "~/components/settings/LanguageSelector";
import "~/css/Header.css";
import { useAtom } from "jotai/index";
import { isDispClockAtom } from "~/Atom";
import { useLogoSettings } from "~/components/settings/HamburgerMenu/hooks/useLogoSettings";

const Header: React.FC = () => {
  const [isDispClock] = useAtom(isDispClockAtom);
  const { displayLogo } = useLogoSettings();

  return (
    <div className="header">
      {isDispClock && <Clock />}
      <h1>
        <img src={displayLogo} alt="" className="logo" style={{ cursor: "default", zIndex: 10 }} />
      </h1>
      <LanguageSelector />
    </div>
  );
};

export default Header;
